const testimonials = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20vector%20avatar%20illustration%20of%20a%20young%20girl%20with%20round%20glasses%20and%20short%20hair%2C%20simple%20warm%20color%20palette%2C%20soft%20cream%20background&width=200&height=200&seq=av-01&orientation=squarish',
    name: '小林在吃瓜',
    role: '资深围观群众',
    text: '每次群里爆瓜，我都第一个跑来这翻「震惊」「蹲后续」的表情，配图又快又应景，朋友都说我太会了。',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20vector%20avatar%20illustration%20of%20a%20young%20man%20with%20headphones%20and%20beanie%20hat%2C%20simple%20warm%20color%20palette%2C%20soft%20cream%20background&width=200&height=200&seq=av-02&orientation=squarish',
    name: '不吃瓜会si',
    role: '快乐吃瓜族',
    text: '分类很细，无语、偷笑、阴阳怪气都能一秒找到。更新也快，热点一出表情就上线，太懂我们围观人了。',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20vector%20avatar%20illustration%20of%20a%20woman%20with%20ponytail%20and%20warm%20smile%2C%20simple%20warm%20color%20palette%2C%20soft%20cream%20background&width=200&height=200&seq=av-03&orientation=squarish',
    name: '阿瓜同学',
    role: '宿舍群群主',
    text: '宿舍群全靠这些表情撑场面，「吃瓜群众集合」「坐等反转」一发，整个群都热闹起来，谁用谁知道。',
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
              <i className="ri-heart-3-line" /> 围观人自己的表情站
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">关于吃瓜表情站</h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              吃瓜表情站是一处专为「吃瓜群众」打造的表情包聚集地。我们深知围观这件事最重要的就是配图要到位，于是把散落在各处的围观表情收拢成库，按「震惊、无语、偷笑看戏、蹲后续、阴阳怪气」等场景分门别类，让你想表达什么都能一步到位。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-700">
              从日常聊天到热点围观，我们坚持免费、海量、每日上新。挑一张最对味的表情包甩出去，你的吃瓜也能更有梗、更带劲。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {[
                { num: '1200+', label: '表情素材' },
                { num: '30+', label: '围观场景' },
                { num: '每日', label: '实时上新' },
                { num: '0元', label: '全部免费' },
              ].map((s) => (
                <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 px-5 py-3">
                  <p className="font-heading text-2xl text-primary-600">{s.num}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3">
              <h3 className="font-heading text-xl text-foreground-950">围观群众这样说</h3>
              <div className="flex items-center gap-0.5 text-secondary-500">
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
              </div>
              <span className="text-xs text-foreground-500">4.9 / 5</span>
            </div>
            <div className="mt-5 flex flex-col gap-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-3">
                    <img src={t.avatar} alt={`吃瓜表情站用户${t.name}头像`} className="h-11 w-11 rounded-full object-cover" />
                    <div>
                      <figcaption className="text-sm font-medium text-foreground-900">{t.name}</figcaption>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-600">{t.text}</blockquote>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}